import React, { useEffect, useState, useMemo, useContext } from "react";
import { Typography } from "@mui/material";

import JoinedCampaigns from "../components/JoinedCampaigns";
import PageLayout from "@/components/layouts/page/PageLayout";
import { campaignService } from "@/features/campaigns/shared/services/campaignService";
import useFetcher from "@/helpers/hooks/useFetcher";
import { LoaderContext, GlobalContext } from "@/helpers/contexts/contexts";
import MuiSearchInput from "@/components/muiCustom/search/MuiSearchInput";

type JoinedCampaignFilters = {
  pageIndex: number;
  searchKey: string;
  sortBy: string;
  sortByDir: string;
};

type ParticipantData = {
  id?: string | number;
  system_generated_participant_id?: string | number;
};

const JoinedDigitalCampaignListPage = () => {
  const loader = useContext(LoaderContext);
  const { selectedBrand, loggedInUser } = useContext(GlobalContext);
  const participantData = loggedInUser?.participantData as
    | ParticipantData
    | undefined;

  const [filters, setFilters] = useState<JoinedCampaignFilters>({
    pageIndex: 0,
    searchKey: "",
    sortBy: "",
    sortByDir: "",
  });

  const [pageCount, setPageCount] = useState(0);

  const handleSearchChange = (value: string) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      searchKey: value,
      pageIndex: 0,
    }));
  };

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageIndex: value - 1,
    }));
  };

  const reqData = useMemo(
    () => ({
      id: selectedBrand?.id,
      userId: participantData?.id,
      page: filters.pageIndex + 1,
      searchKey: filters.searchKey || "",
      sortBy: filters.sortBy || "",
      sortByDir: filters.sortByDir || "",
      fk_participant_id: participantData?.id,
      participant_id: participantData?.system_generated_participant_id,
    }),
    [selectedBrand?.id, participantData, filters]
  );

  const { data, isLoading, isValidating } = useFetcher(
    reqData,
    campaignService.getCampaignReportListing,
    { revalidateOnFocus: false }
  );

  const joinedCampaignData = data as any;
  const recordsTotal = joinedCampaignData?.recordsTotal || 0;

  useEffect(() => {
    if (joinedCampaignData) {
      setPageCount(joinedCampaignData.pageCount || 0);
    }
  }, [joinedCampaignData]);

  useEffect(() => {
    loader(isLoading || isValidating);
  }, [isLoading, loader, isValidating]);

  return (
    <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
      <div className="dashboard participant-dashboard">
        <Typography variant="h5" className="widget-title mb-4 mb-md-auto">
          Digital Campaigns
        </Typography>
        <div className="row py-sm-3 ">
          <div className="col-lg-4 offset-lg-8">
            <div className="search-container">
              <MuiSearchInput
                value={filters.searchKey}
                onChange={handleSearchChange}
                name="searchKey"
              />
            </div>
          </div>
        </div>
        <JoinedCampaigns
          joinedCampaigns={joinedCampaignData?.result || []}
          pageCount={pageCount}
          pageIndex={filters.pageIndex}
          onPageChange={handlePageChange}
          recordsTotal={recordsTotal}
          isLoading={isLoading}
        />
      </div>
    </PageLayout>
  );
};

export default JoinedDigitalCampaignListPage;
